const KEY = "mlobox_saved_address_v1";

export const loadSavedAddress = () => {
  try {
    const a = JSON.parse(localStorage.getItem(KEY));
    return a && a.building && a.door_number && typeof a.lat === "number" ? a : null;
  } catch {
    return null;
  }
};

export const saveAddress = (a) => localStorage.setItem(KEY, JSON.stringify(a));
export const forgetAddress = () => localStorage.removeItem(KEY);
